import React from "react";
import { Select, Tag } from "antd";

import { STATUS_CATEGORY_COLORS } from "../../constants/projects.constants";

import type { Status } from "../../../../core/data/redux/projects/types";

interface StatusPickerProps {
  statuses: Status[];
  value: number | null | undefined;
  onChange: (statusId: number) => void;
  disabled?: boolean;
  size?: "small" | "middle" | "large";
}

const StatusPicker: React.FC<StatusPickerProps> = ({
  statuses,
  value,
  onChange,
  disabled,
  size = "middle",
}) => {
  return (
    <Select
      style={{ width: "100%", height: 36 }}
      value={value ?? undefined}
      onChange={onChange}
      disabled={disabled}
      size={size}
      placeholder="Select status"
      options={statuses.map((s) => ({
        value: s.id,
        label: (
          <span className="d-inline-flex align-items-center gap-2">
            <span
              className="d-inline-block rounded-circle"
              style={{
                width: 8,
                height: 8,
                background: s.color || STATUS_CATEGORY_COLORS[s.category],
              }}
            />
            {s.name}
            <Tag style={{ marginLeft: "auto" }}>{s.category}</Tag>
          </span>
        ),
      }))}
    />
  );
};

export default StatusPicker;
